import { CancelRounded } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import UnverifiedIcon from "@mui/icons-material/GppBad";
import VerifiedIcon from "@mui/icons-material/GppGood";
import SecurityIcon from "@mui/icons-material/Security";
import EditIcon from "@mui/icons-material/Edit";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import {
  getGridBooleanOperators,
  getGridStringOperators,
  GridActionsCellItem,
} from "@mui/x-data-grid-pro";
import { timestampColumn } from "../DataGrid/ColumnHelpers";

export const getColumnDefinition = ({
  handleMakeAdmin,
  handleRevokeAdmin,
  handleEditPermissions,
  canManage,
}) => [
  {
    field: "id",
    headerName: "ID",
    width: 90,
    filterOperators: () => {
      getGridStringOperators().filter(
        (operator) =>
          operator.value === "contains" || operator.value === "equals"
      );
    },
  },
  {
    field: "displayName",
    headerName: "Full name",
    description: "This column has a value getter and is not sortable.",
    width: 160,
    valueGetter: (params) =>
      params.row.firstName
        ? `${params.row.firstName || ""} ${params.row.lastName || ""}`
        : params.row.displayName,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains" || operator.value === "equals"
    ),
  },
  {
    field: "email",
    headerName: "Email Address",
    width: 260,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains" || operator.value === "equals"
    ),
  },
  {
    field: "emailVerified",
    headerName: "Verified",
    type: "boolean",
    renderCell: ({ value }) => {
      return value ? (
        <VerifiedIcon color="success" />
      ) : (
        <UnverifiedIcon color="disabled" />
      );
    },
    width: 100,
    filterOperators: getGridBooleanOperators(),
  },
  {
    field: "isAdmin",
    headerName: "Is Admin",
    type: "boolean",
    renderCell: ({ value }) => {
      return value ? (
        <CheckCircleIcon color="success" />
      ) : (
        <CancelRounded color="error" />
      );
    },
    width: 100,
    filterOperators: getGridBooleanOperators(),
  },
  {
    field: "isArchived",
    headerName: "Is Archived",
    type: "boolean",
    renderCell: ({ value }) => {
      return value ? (
        <DoNotDisturbOnIcon color="info" />
      ) : (
        <DoNotDisturbOnIcon color="disabled" />
      );
    },
    width: 100,
    filterOperators: getGridBooleanOperators(),
  },
  {
    field: "permissions",
    headerName: "Permissions",
    width: 200,
    valueGetter: (params) => params.row.permissions?.join(", ") || "",
  },
  timestampColumn({
    field: "createdAt",
    headerName: "Created At",
  }),
  timestampColumn({
    field: "lastSignIn",
    headerName: "Last Signed In",
  }),
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    width: 80,
    getActions: (params) =>
      !canManage
        ? []
        : [
            <GridActionsCellItem
              icon={<SecurityIcon />}
              label="Make Admin"
              onClick={() => handleMakeAdmin(params.id)}
              showInMenu
              disabled={params.row.isAdmin}
            />,
            <GridActionsCellItem
              icon={<SecurityIcon />}
              label="Revoke Admin"
              onClick={() => handleRevokeAdmin(params.id)}
              showInMenu
              disabled={!params.row.isAdmin}
            />,
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit Permissions"
              onClick={() =>
                handleEditPermissions(params.id, params.row.permissions || [])
              }
              showInMenu
              disabled={!params.row.isAdmin}
            />,
          ],
  },
];
